/*
  Yurls Shop — zoeken en filteren in de veelgestelde vragen.

  Alles staat al op de pagina; dit script verbergt alleen wat niet past. Laadt
  het script niet, dan zie je gewoon alle vragen — dat is een prima uitkomst.

  In een omhulsel, want dit bestand kan door meerdere secties op dezelfde
  pagina worden binnengehaald.
*/

(() => {
  class YurlsFaq extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-search]');
      this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-topic]'));
      this.empty = this.querySelector('[data-empty]');
      this.echo = this.querySelector('[data-echo]');

      if (this.cards.length === 0) return;

      this.topic = '';

      if (this.search) {
        this.search.addEventListener('input', () => this.update());
      }

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.topic = button.dataset.filter;
          this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
          this.update();
        });
      });

      this.update();
    }

    update() {
      const query = this.search ? this.search.value.trim().toLowerCase() : '';
      let zichtbaar = 0;

      this.cards.forEach((card) => {
        const past = this.topic === '' || card.dataset.topic === this.topic;
        let raak = 0;

        card.querySelectorAll('[data-zoek]').forEach((item) => {
          const treffer = query === '' || item.dataset.zoek.indexOf(query) !== -1;
          item.hidden = !treffer;
          if (treffer) raak += 1;

          /*
            Bij een zoekopdracht klappen de treffers open, anders moet je nog
            een keer klikken om te zien of het antwoord klopt. Wist je de
            zoekterm, dan gaan ze weer dicht.
          */
          if (query.length > 2) item.open = treffer;
          if (query === '') item.open = false;
        });

        const toon = past && raak > 0;
        card.hidden = !toon;
        if (toon) zichtbaar += 1;
      });

      if (this.empty) {
        this.empty.hidden = zichtbaar > 0;
        if (this.echo) this.echo.textContent = this.search ? this.search.value.trim() : '';
      }
    }
  }

  if (!customElements.get('yurls-faq')) {
    customElements.define('yurls-faq', YurlsFaq);
  }
})();